import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";
import {footerNotificationActivePicto, footerNotificationPicto} from "../../Theme/picto";

export interface FooterNotificationActivePictoProps extends pictoProps {
}

export interface FooterNotificationActivePictoState extends pictoState {
}

export class FooterNotificationActivePicto extends Picto<FooterNotificationActivePictoProps,FooterNotificationActivePictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.footerNotificationActivePicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(FooterNotificationActivePicto);
